var global = require('../internals/global');

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/number-is-finite.js
// module id = 1014
// module chunks = 1